import templateStr from 'text!./templates/policy-coverages.html';
import _ from 'underscore';

export default [function () {
    return {
        restrict: 'E',
        template: templateStr,
        scope: {
            'policy': '=',
            'period': '='
        },
        controller: ['$scope', 'PolicyService', function ($scope, PolicyService) {

            $scope.namedInsuredMailingAddress = { displayName: '' };

            PolicyService.getAccountPolicyDetails($scope.period.policyNumber).then(function (policyData) {
                $scope.selectedPeriod = policyData.currentPeriod;

                var namedInsuredContact = $scope.selectedPeriod.contacts.find(function (a) {
                    return a.contactRole === 'Named Insured';
                });
                if (namedInsuredContact && namedInsuredContact.contact && namedInsuredContact.contact.primaryAddress) {
                    $scope.namedInsuredMailingAddress = namedInsuredContact.contact.primaryAddress;
                    console.log('$scope.namedInsuredMailingAddress', $scope.namedInsuredMailingAddress);
                }
            });

            // Use generic coverage directive if none of the lobs objects have data
            $scope.$watch('policy', function (policy) {
                if (policy) {
                    $scope.useGenericCoverages = policy.lobs && _.every(policy.lobs, function (lob) {
                        return _.isEmpty(lob);
                    });
                }
            });
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/policy/directives/PolicyCoverages.js
// module id = 2219
// module chunks = 0